import OpenFolderBackdrop from './OpenFolderBackdrop';

export default OpenFolderBackdrop;
